import { HEALTH_ENROLLMENT_STATUSES } from 'platform/shared/health-apps';
import React from 'react';
import { useSelector } from 'react-redux';
import content from '../../../../locales/en/content.json';
import { createLiteralMap } from '../../../../utils/helpers';
import { selectParsedStatus } from '../../../../selectors';

const WarningHeadline = () => {
  const parsedStatus = useSelector(selectParsedStatus);

  const contentDictionary = [
    [
      content['enrollment-alert-title--enrolled'],
      [HEALTH_ENROLLMENT_STATUSES.enrolled],
    ],
    [
      content['enrollment-alert-title--inelig'],
      [
        HEALTH_ENROLLMENT_STATUSES.ineligCharacterOfDischarge,
        HEALTH_ENROLLMENT_STATUSES.ineligCitizens,
        HEALTH_ENROLLMENT_STATUSES.ineligFilipinoScouts,
        HEALTH_ENROLLMENT_STATUSES.ineligFugitiveFelon,
        HEALTH_ENROLLMENT_STATUSES.ineligGuardReserve,
        HEALTH_ENROLLMENT_STATUSES.ineligMedicare,
        HEALTH_ENROLLMENT_STATUSES.ineligNotEnoughTime,
        HEALTH_ENROLLMENT_STATUSES.ineligNotVerified,
        HEALTH_ENROLLMENT_STATUSES.ineligOther,
        HEALTH_ENROLLMENT_STATUSES.ineligOver65,
        HEALTH_ENROLLMENT_STATUSES.ineligRefusedCopay,
        HEALTH_ENROLLMENT_STATUSES.ineligTrainingOnly,
        HEALTH_ENROLLMENT_STATUSES.ineligCHAMPVA,
      ],
    ],
    [
      content['enrollment-alert-title--reapply'],
      [
        HEALTH_ENROLLMENT_STATUSES.rejectedIncWrongEntry,
        HEALTH_ENROLLMENT_STATUSES.rejectedRightEntry,
        HEALTH_ENROLLMENT_STATUSES.rejectedScWrongEntry,
        HEALTH_ENROLLMENT_STATUSES.canceledDeclined,
        HEALTH_ENROLLMENT_STATUSES.closed,
      ],
    ],
    [
      content['enrollment-alert-title--active-duty'],
      [HEALTH_ENROLLMENT_STATUSES.activeDuty],
    ],
    [
      content['enrollment-alert-title--deceased'],
      [HEALTH_ENROLLMENT_STATUSES.deceased],
    ],
    [
      content['enrollment-alert-title--means-test'],
      [HEALTH_ENROLLMENT_STATUSES.pendingMt],
    ],
    [
      content['enrollment-alert-title--review'],
      [
        HEALTH_ENROLLMENT_STATUSES.pendingOther,
        HEALTH_ENROLLMENT_STATUSES.pendingUnverified,
        HEALTH_ENROLLMENT_STATUSES.pendingPurpleHeart,
      ],
    ],
    [
      content['enrollment-alert-title--non-military'],
      [HEALTH_ENROLLMENT_STATUSES.nonMilitary],
    ],
  ];

  const contentMap = createLiteralMap(contentDictionary);

  return (
    <h2 slot="headline" data-testid="hca-enrollment-alert-heading">
      {contentMap[parsedStatus]}
    </h2>
  );
};

export default WarningHeadline;
